// from bulma responsiveness https://bulma.io/documentation/overview/responsiveness/
export const WindowBreakpoint = Object.freeze({
  xs: 0,
  sm: 768,
  md: 1024,
  lg: 1216,
  xl: 1408
})
